"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CurrencyDisplay = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const CurrencyDisplay = ({ currencySignPosition, currencySign, children, }) => {
    return currencySignPosition === 'after' ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [children, currencySign] })) : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [currencySign, children] }));
};
exports.CurrencyDisplay = CurrencyDisplay;
//# sourceMappingURL=index.js.map